import { Component } from '@angular/core';

import { AutocompleteSelectFieldComponent } from './autocomplete-select-field.component';

@Component({
  selector: 'app-jumbo-select-field-component',
  templateUrl: './autocomplete-select-field.component.html',
  styleUrls: ['./jumbo-select-field.component.scss']
})
export class JumboSelectFieldComponent extends AutocompleteSelectFieldComponent {

}


// WEBPACK FOOTER //
// ./src/app/forms/jumbo-select-field.component.ts